import { render, staticRenderFns } from "./resumoCertificado.vue?vue&type=template&id=abb50fee"
import script from "./resumoCertificado.vue?vue&type=script&lang=js"
export * from "./resumoCertificado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports